import i18n from 'i18next';
import ChainedBackend, { ChainedBackendOptions } from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';

import login from '../locales/ko/login.json';

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(ChainedBackend)
  .use(initReactI18next)
  .init<ChainedBackendOptions>({
    backend: {
      backends: [
        HttpBackend,
        resourcesToBackend({
          ko: {
            loginLocal: login,
          },
        }),
      ],
      backendOptions: [
        { loadPath: 'https://caas-locales.s3.ap-northeast-2.amazonaws.com/{{lng}}/{{ns}}.json' },
      ],
    },
    ns: ['global', 'error_code', 'error_page', 'login'],
    lng: 'ko',
    fallbackLng: ['ko'],
    interpolation: { escapeValue: false },
    react: {
      useSuspense: true,
    },
    load: 'languageOnly',
    supportedLngs: ['ko', 'en', 'vi', 'pl', 'de', 'id', 'ja', 'th', 'es', 'zh_cn', 'zh_tw'],
  });

export default i18n;
